import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  healthRating: {
    display: "flex",
    alignItems: "center",
    position: "relative"
  },
  healthRatingButton: {
    fontFamily: "SuisseIntlMedium",
    minWidth: 32,
    padding: 3,
    border: `1px solid ${theme.palette.text.hint}`,
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.15)",
    borderRadius: "4px",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#fff"
    }
  },
  dialog: {
    margin: "0 auto"
  },
  dialogPaper: {
    maxWidth: 372
  },
  dialogTitle: {
    borderBottom: "1px solid #ccc"
  },
  dialogTitleDescription: {
    fontSize: "12px",
    margin: "8px 0"
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px 24px 16px"
  },
  confirmButton: {
    color: theme.palette.secondary.dark
  }
}));
